import React from "react";
import ReactDOM from "react-dom/client";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { UserProvider } from "./contexts/userContext";

const domain = "dev-qym8p8oypn0lsq3v.uk.auth0.com";
const clientId = "XmLyglgU5GXeSeq9EFhbgrkmNHGG4SeW";

const AuthProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || "/calculator", { replace: true });
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
  
      authorizationParams={{
  redirect_uri: window.location.origin + "/callback",
  scope: "openid profile email",
}}

      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProviderWithNavigate>
        <UserProvider>
          <App />
        </UserProvider>
      </AuthProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);
